// @flow
import React from 'react'
import I18n from 'i18n-react'
import { BoolNegation } from '../../Components/_formFields'
import type { DefaultMiniAppProps } from './'
import PhoneInput from '../bonusMalus/PhoneInput'

type PhoneAppProps = DefaultMiniAppProps & {
  isBackOffice?: boolean,
  isBonusMalus?: boolean,
  isInModal?: boolean,
}

export default class PhoneApp extends React.Component<PhoneAppProps> {
  static defaultProps = {
    isBackOffice: false,
    isBonusMalus: true,
    isInModal: false,
  }

  handleOnPhoneChange = (value: string) => {
    const { onChangeFormData } = this.props
    const newFormData = {
      policyHolder: {
        phoneNumber: value,
      },
    }
    onChangeFormData(newFormData, ['policyHolder', 'phoneNumber'])
  }

  handleOnOffersChange = (value: string) => {
    const { onChangeFormData } = this.props
    const newFormData = {
      noPrivateOffers: value,
    }
    onChangeFormData(newFormData, ['noPrivateOffers'])
  }

  render() {
    const { content, formData, isBackOffice, isBonusMalus, isInModal, pushIsPristine, validationErrors } = this.props

    let errors = validationErrors
    if (validationErrors && validationErrors.policyHolder) {
      errors = validationErrors.policyHolder
    }

    let phoneNumber = formData && formData.policyHolder ? formData.policyHolder.phoneNumber : ''

    const privateOffersField = content.components && content.components.noPrivateOffers && (
      <div
        className="form-group d-flex flex-row flex-wrap flex-sm-row align-items-center boolNegation-group"
        key="noPrivateOffers"
      >
        <div className="col-12 col-sm-5 offset-sm-4 mb-1 mt-1">
          <BoolNegation
            id="noPrivateOffers"
            label={content.fieldNames.noPrivateOffers}
            name="noPrivateOffers"
            negationLabel={content.components.noPrivateOffers.negationLabel}
            onChange={this.handleOnOffersChange}
            value={formData.noPrivateOffers}
          />
        </div>
      </div>
    )

    return [
      isInModal && isBonusMalus ? (
        <div className="alert alert-info m-r-2 m-l-2" key="PhoneApp-alert-top" role="alert">
          <span>{I18n.translate('miniApps.phoneApp.topAlert')}</span>
        </div>
      ) : null,
      !isInModal &&
        !isBackOffice &&
        isBonusMalus && [
          formData.bonusType === 'notSure' && (
            <div className={`form-group d-flex flex-row flex-wrap flex-sm-row align-items-center alert-group`}>
              <div className={'col-12'}>
                <div className={`alert alert-info mb-0`} key="bonusMalus-alert-bottom" role="alert">
                  <span>
                    Nevadí, vaše <strong>bonusy rádi zjistíme po telefonu</strong>. S ověřeným nárokem na slevu u devíti
                    pojišťoven bude vaše <strong>cena až o 60% nižší</strong> a navíc finální. Pro ověření přesné ceny
                    nám bude stačit jen pár údajů. Navíc můžete získat i neveřejné nabídky, které máme s pojišťovnami
                    vyjednané.
                  </span>
                </div>
              </div>
            </div>
          ),
          formData.bonusType === 'manually' && (
            <div className="form-group d-flex flex-row flex-wrap flex-sm-row align-items-center alert-group">
              <div className="col-12">
                <div className="alert alert-info mb-0" key="bonusMalus-alert-bottom" role="alert">
                  <span>{I18n.translate('miniApps.bonusMalus.infoBottomManually')}</span>
                </div>
              </div>
            </div>
          ),
        ],
      <PhoneInput
        key="phoneInput"
        onPhoneChange={this.handleOnPhoneChange}
        phoneNumber={phoneNumber}
        phoneNumberLabel={content.fieldNames.phoneNumber}
        pushIsPristine={pushIsPristine}
        validationErrors={errors}
      />,
      formData.bonusType !== 'notSure' && privateOffersField,
      isInModal && isBonusMalus ? (
        <div className="my-2" key="PhoneApp-info">
          <i>{I18n.translate('miniApps.phoneApp.info')}</i>
        </div>
      ) : null,
    ]
  }
}
